import React from 'react'

function Contact() {
    return (
        <div>
            This is the Contact Us Page
        </div>
    )
}

export default Contact
